import React, { useState, useEffect } from 'react';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const DiscountBanner = ({ onBookNowClick }) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 15,
    hours: 8,
    minutes: 45,
    seconds: 30
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev?.seconds > 0) {
          return { ...prev, seconds: prev?.seconds - 1 };
        } else if (prev?.minutes > 0) {
          return { ...prev, minutes: prev?.minutes - 1, seconds: 59 };
        } else if (prev?.hours > 0) {
          return { ...prev, hours: prev?.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev?.days > 0) {
          return { ...prev, days: prev?.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-12 bg-gradient-to-r from-primary to-secondary relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-4 left-4">
          <Icon name="TreePine" size={48} className="text-white" />
        </div>
        <div className="absolute top-8 right-8">
          <Icon name="Mountain" size={40} className="text-white" />
        </div>
        <div className="absolute bottom-4 left-1/4">
          <Icon name="Waves" size={36} className="text-white" />
        </div>
        <div className="absolute bottom-8 right-1/4">
          <Icon name="Sun" size={44} className="text-white" />
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Icon name="Zap" size={16} className="text-accent" />
            <span className="text-white font-medium text-sm">Limited Time Offer</span>
          </div>

          {/* Main Content */}
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-white mb-4">
            Monsoon Special - Up to 40% Off
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Experience the magic of Dandeli during monsoon season with exclusive discounts on all accommodations and adventure packages
          </p>

          {/* Countdown Timer */}
          <div className="flex justify-center space-x-4 mb-8">
            {Object.entries(timeLeft)?.map(([unit, value]) => (
              <div key={unit} className="bg-white/20 backdrop-blur-sm rounded-lg p-4 min-w-[80px]">
                <div className="text-2xl lg:text-3xl font-heading font-bold text-white">
                  {value?.toString()?.padStart(2, '0')}
                </div>
                <div className="text-sm text-white/80 capitalize">
                  {unit}
                </div>
              </div>
            ))}
          </div>

          {/* Offer Details */}
          <div className="grid md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <Icon name="Percent" size={32} className="text-accent mx-auto mb-3" />
              <h3 className="text-lg font-heading font-semibold text-white mb-2">
                40% Off Accommodation
              </h3>
              <p className="text-white/80 text-sm">
                On all room types for stays between Sept 20 - Oct 31, 2025
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <Icon name="Gift" size={32} className="text-accent mx-auto mb-3" />
              <h3 className="text-lg font-heading font-semibold text-white mb-2">
                Free Adventure Package
              </h3>
              <p className="text-white/80 text-sm">
                Complimentary jungle safari and river rafting with 3+ night stays
              </p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <Icon name="Utensils" size={32} className="text-accent mx-auto mb-3" />
              <h3 className="text-lg font-heading font-semibold text-white mb-2">
                Meals Included
              </h3>
              <p className="text-white/80 text-sm">
                All meals and evening snacks included in the special package
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="default"
              size="lg"
              iconName="Calendar"
              iconPosition="left"
              onClick={onBookNowClick}
              className="bg-white text-primary hover:bg-white/90 px-8 py-3"
            >
              Book Now & Save 40%
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              className="border-white text-white hover:bg-white hover:text-primary px-8 py-3"
            >
              Call for Details
            </Button>
          </div>

          {/* Terms */}
          <p className="text-white/60 text-xs mt-6">
            *Terms and conditions apply. Offer valid for new bookings only. Cannot be combined with other offers.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DiscountBanner;